var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dialog-base",
    {
      attrs: {
        visible: _vm.visible,
        title: "Đồng bộ thiết bị",
        size: "md",
        "use-panel": false,
        "show-confirm": true,
        "confirm-text": "Đồng bộ",
        "cancel-text": "Đóng",
        "confirm-icon": "el-icon-refresh",
        "confirm-loading": _vm.confirmingSync || _vm.startingSyncJob,
        "confirm-disabled":
          _vm.loadingSchools ||
          _vm.loadingDevices ||
          _vm.restoringSyncJobs ||
          _vm.synchronizationRunning ||
          _vm.devices.length < 2,
        "cancel-disabled": _vm.confirmingSync || _vm.startingSyncJob,
        "close-on-cancel": false,
        "before-close": _vm.closeDialog,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        cancel: _vm.closeDialog,
        confirm: _vm.submit,
      },
    },
    [
      _c("el-alert", {
        staticClass: "sync-notice",
        attrs: {
          title:
            "Dữ liệu nhận diện đang quản lý trên thiết bị mới sẽ được xóa trước khi sao chép từ thiết bị cũ.",
          type: "warning",
          "show-icon": "",
          closable: false,
        },
      }),
      _c(
        "el-form",
        {
          ref: "syncForm",
          attrs: {
            model: _vm.form,
            rules:
              _vm.syncing ||
              _vm.loadingSchools ||
              _vm.loadingDevices ||
              _vm.restoringSyncJobs
                ? {}
                : _vm.rules,
            "validate-on-rule-change": false,
            "label-position": "top",
          },
        },
        [
          _c("DeviceSynchronizationProgress", {
            attrs: {
              job: _vm.syncJob,
              jobs: _vm.syncJobs,
              error: _vm.trackingError,
              loading: _vm.restoringSyncJobs,
            },
            on: {
              select: _vm.selectSynchronizationJob,
              refresh: function ($event) {
                return _vm.refreshSynchronizationJobs()
              },
            },
          }),
          _c(
            "el-form-item",
            { attrs: { label: "Trường học", prop: "idSchool" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "sync-control",
                  attrs: {
                    filterable: "",
                    loading: _vm.loadingSchools,
                    disabled: _vm.syncing || _vm.loadingSchools,
                    placeholder: "Chọn trường học",
                  },
                  on: {
                    change: function ($event) {
                      return _vm.loadDevices()
                    },
                  },
                  model: {
                    value: _vm.form.idSchool,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "idSchool", $$v)
                    },
                    expression: "form.idSchool",
                  },
                },
                _vm._l(_vm.schools, function (school) {
                  return _c("el-option", {
                    key: school.id,
                    attrs: { value: school.id, label: school.name },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Thiết bị cũ (nguồn)", prop: "idDeviceOld" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "sync-control",
                  attrs: {
                    filterable: "",
                    loading: _vm.loadingDevices,
                    disabled:
                      _vm.syncing ||
                      _vm.loadingSchools ||
                      _vm.loadingDevices ||
                      !_vm.form.idSchool,
                    placeholder: "Chọn thiết bị cũ",
                  },
                  on: { change: _vm.handleSourceChange },
                  model: {
                    value: _vm.form.idDeviceOld,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "idDeviceOld", $$v)
                    },
                    expression: "form.idDeviceOld",
                  },
                },
                _vm._l(_vm.devices, function (device) {
                  return _c("el-option", {
                    key: device.id,
                    attrs: { value: device.id, label: _vm.deviceLabel(device) },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "Thiết bị mới (đích)", prop: "idDeviceNew" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "sync-control",
                  attrs: {
                    filterable: "",
                    loading: _vm.loadingDevices,
                    disabled:
                      _vm.syncing ||
                      _vm.loadingSchools ||
                      _vm.loadingDevices ||
                      !_vm.form.idSchool,
                    placeholder: "Chọn thiết bị mới",
                  },
                  model: {
                    value: _vm.form.idDeviceNew,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "idDeviceNew", $$v)
                    },
                    expression: "form.idDeviceNew",
                  },
                },
                _vm._l(_vm.devices, function (device) {
                  return _c("el-option", {
                    key: device.id,
                    attrs: {
                      value: device.id,
                      label: _vm.deviceLabel(device),
                      disabled:
                        String(device.id) === String(_vm.form.idDeviceOld),
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm.form.idSchool &&
          !_vm.loadingSchools &&
          !_vm.loadingDevices &&
          _vm.devices.length < 2
            ? _c("p", { staticClass: "sync-note" }, [
                _vm._v(
                  "\n      Trường cần có ít nhất hai thiết bị để thực hiện đồng bộ.\n    "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }